module.exports = __webpack_public_path__ + "img/binder.08d63fd6.svg";